import { Link } from "react-router-dom";

const styleInput =
  "block w-full px-4 py-2.5 mt-1.5 text-gray-700 dark:text-gray-100 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/30 dark:focus:ring-primary/40 placeholder-gray-400 dark:placeholder-gray-500 transition-colors";

const styleSelect =
  "block w-full px-4 py-2.5 mt-1.5 text-gray-700 dark:text-gray-100 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/30 dark:focus:ring-primary/40 transition-colors";

const styleCheckbox = "form-checkbox h-5 w-5 accent-primary rounded";

const FormField = function (props) {
  const {
    id,
    name,
    type,
    minLength,
    maxLength,
    placeholder,
    errors,
    register,
    validation,
    toggleIcon,
    value,
    options,
    label,
    required,
    valueAsNumber,
    errorCheckbox,
    toLink,
    warning,
    rows,
    onChange,
    autoComplete,
  } = props;

  const labelClass = `block text-sm font-medium mb-0.5 ${
    errors[id] ? "text-red-500 dark:text-red-400" : "text-gray-700 dark:text-gray-300"
  }`;

  function renderField() {
    // eslint-disable-next-line default-case
    switch (type) {
      case "text":
      case "email":
      case "number":
      case "date":
      case "password":
        return (
          <div className="relative">
            {label && (
              <label className={labelClass} htmlFor={id}>
                {label}
                {required && <span className="text-red-400 ml-0.5">*</span>}
              </label>
            )}
            <input
              id={id}
              name={name}
              type={type}
              value={value}
              minLength={minLength}
              maxLength={maxLength}
              placeholder={placeholder}
              autoComplete={autoComplete}
              className={`${styleInput}
                ${errors[id] ? "border-red-500 dark:border-red-400 ring-2 ring-red-500/20" : ""} `}
              {...register(id, {
                onChange: onChange,
                valueAsNumber: valueAsNumber,
                required: {
                  value: required,
                  message: (
                    <>
                      <span className="capitalize">{name}</span>
                      <span> es requerido.</span>
                    </>
                  ),
                },
                minLength: {
                  value: minLength,
                  message: `Mínimo ${minLength} caracteres`,
                },
                maxLength: {
                  value: maxLength,
                  message: `Máximo ${maxLength} caracteres`,
                },

                pattern: {
                  value: validation,
                  message: (
                    <>
                      <span className="capitalize">{name}</span>
                      {warning ? warning : <span> no es válido.</span>}
                    </>
                  ),
                },
              })}
            />
            {toggleIcon}
          </div>
        );

      case "textarea":
        return (
          <div>
            {label && (
              <label className={labelClass} htmlFor={id}>
                {label}
                {required && <span className="text-red-400 ml-0.5">*</span>}
              </label>
            )}
            <textarea
              id={id}
              name={name}
              value={value}
              rows={rows}
              placeholder={placeholder}
              className={`${styleInput} resize-none
                ${errors[id] ? "border-red-500 dark:border-red-400 ring-2 ring-red-500/20" : ""} `}
              {...register(id, {
                required: {
                  value: required,
                  message: (
                    <>
                      <span className="capitalize">{name}</span>
                      <span> es requerido.</span>
                    </>
                  ),
                  maxLength: {
                    value: maxLength,
                    message: `Máximo ${maxLength} caracteres`,
                  },
                },

                pattern: {
                  value: validation,
                  message: (
                    <>
                      <span className="capitalize">{name}</span>
                      {warning ? warning : <span> no es válido.</span>}
                    </>
                  ),
                },
              })}
            />
          </div>
        );

      case "select":
        return (
          <div>
            {label && (
              <label className={labelClass} htmlFor={id}>
                {label}
                {required && <span className="text-red-400 ml-0.5">*</span>}
              </label>
            )}
            <select
              id={id}
              value={value}
              className={`${styleSelect}
              ${errors[id] ? "border-red-500 dark:border-red-400 ring-2 ring-red-500/20" : ""} `}
              {...register(id, {
                required: {
                  value: required,
                  message: (
                    <>
                      <span className="capitalize">{name}</span>
                      <span> es requerido.</span>
                    </>
                  ),
                },
              })}
            >
              {options &&
                options.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
            </select>
          </div>
        );

      case "checkbox":
        return (
          <div className="flex gap-2 items-center">
            <input
              id={id}
              type={type}
              value={value}
              label={label}
              className={styleCheckbox}
              {...register(id, {
                required: {
                  value: required,
                  message: errorCheckbox,
                },
              })}
            />
            <label
              className={`text-sm ${
                errors[id] ? "text-red-500 dark:text-red-400" : "text-gray-700 dark:text-gray-300"
              }`}
              htmlFor={id}
            >
              {toLink ? (
                <Link to={toLink} target="_blank">
                  <div className="underline hover:text-primary cursor-pointer">
                    {label}
                  </div>
                </Link>
              ) : (
                label
              )}
            </label>
          </div>
        );

      case "radio":
        return (
          <div className="flex gap-2 items-center">
            <input
              id={id}
              type={type}
              value={value}
              label={label}
              className={styleCheckbox}
              {...register(id, {
                required: {
                  value: required,
                  message: (
                    <>
                      <span className="capitalize">{name}</span>
                      <span> es requerido.</span>
                    </>
                  ),
                },
              })}
            />
            <label
              className={`text-sm ${
                errors[id] ? "text-red-500 dark:text-red-400" : "text-gray-700 dark:text-gray-300"
              }`}
              htmlFor={id}
            >
              {label}
            </label>
          </div>
        );
    }
  }

  return (
    <div>
      {renderField()}
      {errors[id] && (
        <p className="text-red-500 dark:text-red-400 text-xs mt-1.5">{errors[id].message}</p>
      )}
    </div>
  );
};

export default FormField;
